import {dashboardSupplementalHealthStateUniqueIdentifier} from './dashboard-supplemental-health.model';
import {UnknownError} from '../../../shared/symbols';
import {SubmissionSeries} from '../../../dashboard/symbols/submission-series.symbols';
import {SubmissionAdditionalDataBackendModel, SubmissionAdditionalDataForm} from '../../types';

export class LoadSubmissionAdditionalData {
  static readonly type = `${dashboardSupplementalHealthStateUniqueIdentifier} ${LoadSubmissionAdditionalData.name}`;

  constructor(public submissionId: SubmissionSeries[`id`]) {}
}

export class LoadSubmissionAdditionalDataSuccess {
  static readonly type = `${dashboardSupplementalHealthStateUniqueIdentifier} ${LoadSubmissionAdditionalDataSuccess.name}`;

  constructor(public submissionAdditionalData: SubmissionAdditionalDataBackendModel) {}
}

export class LoadSubmissionAdditionalDataFail {
  static readonly type = `${dashboardSupplementalHealthStateUniqueIdentifier} ${LoadSubmissionAdditionalDataFail.name}`;

  constructor(public error: UnknownError) {}
}

export class ManageSubmissionAdditionalData {
  static readonly type = `${dashboardSupplementalHealthStateUniqueIdentifier} ${ManageSubmissionAdditionalData.name}`;

  constructor(
    public submissionId: SubmissionSeries[`id`],
    public submissionAdditionalData: Partial<SubmissionAdditionalDataForm>,
    public isUpdate = false
  ) {}
}

export class ManageSubmissionAdditionalDataSuccess {
  static readonly type = `${dashboardSupplementalHealthStateUniqueIdentifier} ${ManageSubmissionAdditionalDataSuccess.name}`;

  constructor(public submissionAdditionalData: SubmissionAdditionalDataBackendModel) {}
}

export class ManageSubmissionAdditionalDataFail {
  static readonly type = `${dashboardSupplementalHealthStateUniqueIdentifier} ${ManageSubmissionAdditionalDataFail.name}`;

  constructor(public error: UnknownError) {}
}

export class ResetDashboardSupplementalHealthManageLoadingIndicators {
  static readonly type = `${dashboardSupplementalHealthStateUniqueIdentifier} ${ResetDashboardSupplementalHealthManageLoadingIndicators.name}`;
}

export class ResetDashboardSupplementalHealthState {
  static readonly type = `${dashboardSupplementalHealthStateUniqueIdentifier} ${ResetDashboardSupplementalHealthState.name}`;
}
